import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMnFlag = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 51,
	height: 51,
	viewBox: "0 0 51 51",
	fill: "none",
	xmlns: "<http://www.w3.org/2000/svg>",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_1335_53372)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M33.6567 9.22314H49.4613C49.9374 9.22314 50.3234 9.60918 50.3234 10.0853V41.1197C50.3234 41.5958 49.9374 41.9818 49.4613 41.9818H33.6567V9.22314Z",
					fill: "#CD343C"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M33.6572 9.22363H16.9902V41.9824H33.6572V9.22363Z",
					fill: "#41479B"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M1.18535 9.22314H16.9899V41.9817H1.18535C0.709277 41.9817 0.323242 41.5957 0.323242 41.1196V10.0852C0.323242 9.60908 0.709277 9.22314 1.18535 9.22314Z",
					fill: "#CD343C"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M8.69053 22.7729C7.3877 22.7729 6.271 21.9879 5.779 20.8667C5.77871 20.8838 5.77393 20.8997 5.77393 20.9168C5.77393 22.5275 7.07979 23.8334 8.69053 23.8334C10.3013 23.8334 11.607 22.5275 11.607 20.9168C11.607 20.8997 11.6022 20.8838 11.602 20.8668C11.11 21.9879 9.99326 22.7729 8.69053 22.7729Z",
					fill: "#F9CF02"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M8.69043 22.2432C9.86188 22.2432 10.8115 21.2935 10.8115 20.1221C10.8115 18.9506 9.86188 18.001 8.69043 18.001C7.51898 18.001 6.56934 18.9506 6.56934 20.1221C6.56934 21.2935 7.51898 22.2432 8.69043 22.2432Z",
					fill: "#F9CF02"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M7.36475 16.1446C7.36475 16.8768 7.9583 17.4703 8.69043 17.4703C9.42256 17.4703 10.0161 16.8768 10.0161 16.1446C10.0161 15.6144 9.68467 15.548 9.68467 15.3492C9.68467 15.1504 9.8835 14.8853 9.48584 14.5538C9.68467 14.8853 9.35332 14.9516 9.35332 15.2829C9.35332 15.6143 9.48584 15.6144 9.48584 15.8795C9.48584 16.026 9.36709 16.1445 9.2208 16.1445C9.07432 16.1445 8.95576 16.0258 8.95576 15.8795C8.95576 15.6145 9.2208 15.3492 9.2208 14.9515C9.2208 14.5537 9.15449 14.4212 8.95576 14.0897C8.75693 13.7583 8.42549 13.4932 8.69072 13.228C8.29297 13.3605 8.49189 13.8908 8.49189 14.2224C8.49189 14.5538 8.22686 14.7526 8.22686 15.1504C8.22686 15.5481 8.42568 15.6144 8.42568 15.8795C8.42568 16.026 8.30693 16.1445 8.16064 16.1445C8.01436 16.1445 7.89561 16.0258 7.89561 15.8795C7.89561 15.6145 8.02813 15.6145 8.02813 15.2829C8.02813 14.9514 7.69668 14.8852 7.89561 14.5538C7.49785 14.8853 7.69678 15.1504 7.69678 15.3492C7.69619 15.548 7.36475 15.6143 7.36475 16.1446Z",
					fill: "#F9CF02"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M2.85742 24.5826V36.8715C2.85742 36.9924 2.95547 37.0903 3.07627 37.0903H5.28984C5.41074 37.0903 5.50869 36.9923 5.50869 36.8715V24.5826C5.50869 24.4617 5.41064 24.3638 5.28984 24.3638H3.07627C2.95547 24.3637 2.85742 24.4617 2.85742 24.5826Z",
					fill: "#F9CF02"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M11.8721 24.5826V36.8715C11.8721 36.9924 11.9701 37.0903 12.0909 37.0903H14.3045C14.4254 37.0903 14.5233 36.9923 14.5233 36.8715V24.5826C14.5233 24.4617 14.4253 24.3638 14.3045 24.3638H12.0909C11.97 24.3637 11.8721 24.4617 11.8721 24.5826Z",
					fill: "#F9CF02"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M6.03906 26.7037V27.3265C6.03906 27.4474 6.13711 27.5453 6.25791 27.5453H11.1229C11.2438 27.5453 11.3417 27.4473 11.3417 27.3265V26.7037C11.3417 26.5828 11.2437 26.4849 11.1229 26.4849H6.25791C6.13701 26.4849 6.03906 26.5829 6.03906 26.7037Z",
					fill: "#F9CF02"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M6.03906 34.1275V34.7503C6.03906 34.8712 6.13711 34.9691 6.25791 34.9691H11.1229C11.2438 34.9691 11.3417 34.8711 11.3417 34.7503V34.1275C11.3417 34.0066 11.2437 33.9087 11.1229 33.9087H6.25791C6.13701 33.9087 6.03906 34.0066 6.03906 34.1275Z",
					fill: "#F9CF02"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M6.4343 24.3638H10.9468C11.0578 24.3638 11.0983 24.51 11.0031 24.5671L8.85959 25.8533C8.75559 25.9157 8.62561 25.9157 8.5218 25.8533L6.37805 24.5671C6.28283 24.51 6.32336 24.3638 6.4343 24.3638Z",
					fill: "#F9CF02"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M6.43432 35.5H10.9468C11.0579 35.5 11.0983 35.6462 11.0032 35.7033L8.85942 36.9895C8.75541 37.0519 8.62543 37.0519 8.52163 36.9895L6.37797 35.7032C6.28286 35.6461 6.32338 35.5 6.43432 35.5Z",
					fill: "#F9CF02"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M8.94971 28.0966C8.86611 28.0886 8.78516 28.0713 8.69951 28.0713C7.24141 28.0713 6.05518 29.2575 6.05518 30.7156C6.05518 31.5811 6.47793 32.3428 7.12383 32.8233C7.19814 32.8786 7.29639 32.7987 7.26025 32.7133C7.18281 32.5298 7.13926 32.3287 7.13926 32.117C7.13926 31.2552 7.8417 30.5543 8.7043 30.5569C9.15771 30.5583 9.59238 30.3344 9.79307 29.9277C10.2082 29.0868 9.70166 28.251 8.94971 28.0966ZM8.69951 29.843C8.40752 29.843 8.17061 29.6062 8.17061 29.3141C8.17061 29.0221 8.40742 28.7853 8.69951 28.7853C8.9915 28.7853 9.22832 29.022 9.22832 29.3141C9.22822 29.6062 8.9915 29.843 8.69951 29.843Z",
					fill: "#F9CF02"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M10.2748 28.6076C10.2005 28.5523 10.1022 28.6323 10.1384 28.7177C10.2159 28.9012 10.2594 29.1022 10.2594 29.3139C10.2594 30.1758 9.55682 30.8767 8.69432 30.874C8.2409 30.8726 7.80613 31.0966 7.60555 31.5032C7.19061 32.3442 7.69715 33.1802 8.4491 33.3344C8.5327 33.3424 8.61365 33.3597 8.6993 33.3597C10.1573 33.3597 11.3436 32.1734 11.3436 30.7153C11.3434 29.85 10.9207 29.0883 10.2748 28.6076ZM8.6993 32.6457C8.4073 32.6457 8.17039 32.409 8.17039 32.1168C8.17039 31.8248 8.40721 31.588 8.6993 31.588C8.99129 31.588 9.22811 31.8247 9.22811 32.1168C9.22801 32.4089 8.99129 32.6457 8.6993 32.6457Z",
					fill: "#F9CF02"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_1335_53372",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 50,
				height: 50,
				fill: "white",
				transform: "translate(0.324219 0.602539)"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgMnFlag);
export { ForwardRef as ReactComponent };
